import { Box, IconOptions, Text } from '@jfs/ui-new'
import { TableComponent } from '../../../comps/TableComponent'

import { footerStrings, profileStrings, staticStrings } from '../../../data/static/strings'
import { Routes } from '../../../nav/routes'
import { APIEndPoints } from '../../../network/APIEndpoints'
import { isOsMobile } from '../../../util/util'
import { styles } from './styles'

export const buzzData = (mid: string, buzzName: string, webAddr: string, yearsOfBuzz: string) => {
  return [
    { id: '1', title: 'MID', value: mid },
    { id: '2', title: 'Business Name', value: buzzName ?? '' },
    { id: '3', title: 'Web Address', value: webAddr },
    { id: '4', title: 'Years of Business', value: yearsOfBuzz },
  ]
}

export const notificationData = (email: string, number: string): any[] => {
  return [
    {
      id: '1',
      title: profileStrings.notificationMobileNum,
      value: number,
    },
    { id: '2', title: profileStrings.notificationEmailId, value: email },
  ]
}

export const returnFlatlistHeader = (id: number) => {
  let data
  switch (id) {
    case 0:
      data = 'Business Details'
      break
    case 1:
      data = 'Finance Details'
      break
    case 2:
      data = 'Notification Details'
      break
  }
  return data
}

export const _renderItem = (item: any, index: number, listData: Array<any>) => {
  return (
    <Box {...styles.buttonBox(index + 1 === listData?.length)}>
      <Text {...styles.labelText}>{item?.title}</Text>
      <Text {...styles.descriptionText}>{item?.value}</Text>
    </Box>
  )
}

export const renderParentItem = (itemData: any) => {
  return (
    <Box pv={15}>
      <TableComponent
        scrollEnabled={false}
        value={''} //Routes value
        canFetchMore={false}
        ListContent={itemData?.data}
        hide={false}
        isCustom={true}
        RenderCustomElement={({ item, index }: any) => _renderItem(item, index, itemData?.data)}
        keyExtractor={keyExtractor}
        ListHeaderComponent={() => tableHeaderString(itemData?.header)}
      />
    </Box>
  )
}
export const tableHeaderID = (id: number) => {
  return (
    <Box {...styles.listHeader}>
      <Text {...styles.headerText}>{returnFlatlistHeader(id)}</Text>
    </Box>
  )
}

export const tableHeaderString = (text: string) => {
  return (
    <Box {...styles.listHeader}>
      <Text {...styles.headerText}>{text}</Text>
    </Box>
  )
}

export const keyExtractor = (item: any): string => {
  return item.index
}

export const returnFlatlistData = (selectedMerchantId: string, merchant: any, merchantName: string, id: number) => {
  let data: Array<any> = []
  switch (id) {
    case 0:
      data = buzzData(selectedMerchantId, merchantName, merchant?.contact?.website, merchant?.age)
      break
    case 1:
      data = buzzData(selectedMerchantId, merchantName, merchant?.contact?.website, merchant?.age)
      break
    case 2:
      data = notificationData(merchant?.contact?.email, merchant?.contact?.mobile)
      break
  }
  return data
}

export const newActionData = (
  canViewSettlementBankDetails = false,
  canViewManageUsersTab = false,
  isMobile = false,
) => {
  let settlementBankAccountDetails: any = {
    name: 'Settlement Accounts',
    onPress: Routes.BANKACCOUNT,
    icon: 'SettlementIcon',
  }
  let manageUserScreen: any = {
    name: 'Manage Users',
    onPress: Routes.USER_MANAGEMENT.MANAGE_USERS,
    icon: 'ProfileIcon' as IconOptions,
  }
  let manageNotification = {
    name: 'Manage Notification',
    onPress: Routes.NOTIFICATION_SETTINGS,
    icon: 'NotificationIcon',
  }
  let myDevices = {
    name: 'My Devices',
    onPress: Routes.MY_DEVICES,
    icon: 'MyDeviceIcon',
  }
  const data = [
    // {
    //   name: 'Profile Settings',
    //   index: 1,
    //   onPress: 'ProfileSettingsMobile',
    //   icon: 'ProfileIcon',
    // },
    {
      name: 'Help & Support',
      onPress: Routes.SUPPORT,
      icon: 'SupportIcon',
    },

    // {
    //   name: 'Add Bank',
    //   index: 9,
    //   onPress: 'addbank',
    //   icon: 'ADD' as IconOptions,
    //   mapID: 9,
    // },
    /*{
      name: 'My Bank Account',
      index: 10,
      onPress: Routes.BANKACCOUNT,
      icon: 'BANK' as IconOptions,
      mapID: 10,
    },*/
    // {
    //   name: 'Settings',
    //   index: 14,
    //   onPress: Routes.NOTIFICATION_SETTINGS,
    //   icon: 'SETTING' as IconOptions,
    //   mapID: 10,
    // },
    // {
    //   name: 'Language Preference',
    //   index: 9,
    //   onPress: 'LanguageModal',
    //   icon: 'LanguageIcon',
    //   mapID: 9,
    // },
    {
      name: staticStrings.policyDocuments,
      icon: 'DocumentIcon',
      onPress: 'PolicyDocumentsModal',
    },
    {
      name: 'Logout',
      onPress: 'Logout',
      icon: 'Logout',
    },
  ]
  // allow only if permission are enabled
  // console.log('canViewSettlementBankDetails', canViewSettlementBankDetails)
  // console.log('canViewManageUsersTab', canViewManageUsersTab)
  // console.log('isOsMobile', isOsMobile)
  if (canViewManageUsersTab) {
    data.unshift(manageUserScreen)
  }
  if (isMobile) {
    data.unshift(myDevices)
  }
  if (isMobile) {
    data.unshift(manageNotification)
  }
  if (canViewSettlementBankDetails) {
    data.unshift(settlementBankAccountDetails)
  }
  return data
}

export const policyDocumentsData = () => {
  const policy = [
    {
      name: footerStrings.conditions,
      link: APIEndPoints.tnc,
    },
    {
      name: staticStrings.privacyPolicy,
      link: APIEndPoints.privactPolicy,
    },
    {
      name: staticStrings.grevienceRedressal,
      link: APIEndPoints.grevienceRedressal,
    },
    {
      name: staticStrings.kycAML,
      link: APIEndPoints.kycAML,
    },
  ]
  if (isOsMobile()) {
    policy.push({
      name: staticStrings.billpayTnC,
      link: APIEndPoints.billpayTnC,
    })
  }
  return policy
}
